import React, { Component } from 'react'
import UnAuthRoutes from './config/unAuthRoutes'
import AuthRoutes from './config/AuthRoutes'
import { BrowserRouter as Router, Switch , Route } from 'react-router-dom'
import {connect} from 'react-redux'
import { checkLogin } from './redux/modules/users'
import { RequestPasswordReset } from './components/Users'
import { InvitesContainer, } from './containers'

class App extends Component {
  constructor(props){
    super(props);
  }

  state = {
    user : '',
    token : '',
    isFetching:false,
    isAuthed:false
  }
  componentDidMount(){ 
    if(!this.props.Authed){
      this.props._checkAuth();
    }
   
  }

  componentWillReceiveProps(nextProps){
    let isFetching = false;
    let isAuthed= false;
    if(nextProps.state.isFetching){
      isFetching = true;
    }
    if(nextProps.state.isAuthed){
      isAuthed = true
    }
    function changeCheck(state, isFetching, isAuthed) {
      return ( 
        state.isAuthed !== isAuthed || 
        state.isFetching !== isFetching
      )
    }
    if (changeCheck(this.state, isFetching, isAuthed)) {
      this.setState({ isAuthed, isFetching })
    }
    
  }

  
  

  render() {
    let {isFetching, isAuthed , user} = this.props.state
    return (
      <Router>
        <Switch>
          <UnAuthRoutes path='/reset/:resetId' {...this.props} authed = {this.state.isAuthed} fetching = {this.state.isFetching}/>
          <UnAuthRoutes path='/reset/request-reset' render={ (props) => <RequestPasswordReset {...props}/>} />
          <UnAuthRoutes path='/invites/:inviteId' render={(props) => <InvitesContainer {...props} />} />
          <UnAuthRoutes path="/login" {...this.props} authed = {this.state.isAuthed} fetching = {this.state.isFetching} />
          <UnAuthRoutes path="/signin-username" {...this.props} />
          <AuthRoutes path="/" {...this.props} />
        </Switch>
      </Router>
        )}
}

const mapStateToProps = (state) =>{
  return {
    state : state.users ,
    st : state , 
    testUser : state.users.checkuser ,
    authed : state.users.authed
  }
}

const mapDispatchToProps = (dispatch) => {
  return{
    _checkAuth : ()=> {
      dispatch(checkLogin())
    }
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/App.js